var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "custom-class": "edi-guide-dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.BootHelperPage"),
        "close-on-click-modal": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.onCancel
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { class: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                ref: "tabs",
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleTabClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "operations",
                    staticStyle: { "margin-bottom": "5px", "margin-top": "5px" }
                  },
                  [
                    _c("div", { staticClass: "triggers" }, [
                      _c(
                        "div",
                        { staticClass: "btn-group-look" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "sendEdi", type: "primary" },
                              on: { click: _vm.sendEdi }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Send")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "showEdi", type: "primary" },
                              on: { click: _vm.showEdi }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ViewingMessage"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._l(_vm.docList, function(item) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: item.uuid,
                      attrs: { label: item._name, name: item._name }
                    },
                    [
                      _c("edi-mbl-window", {
                        ref: item._name,
                        refInFor: true,
                        attrs: { context: _vm.context, action: _vm.action }
                      })
                    ],
                    1
                  )
                })
              ],
              2
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }